import {useEffect, useState} from 'react';

const checkHeader = ({action, target}) => {
    const isUnpinned = target?.classList?.contains('unpinned');

    if (action) {
        action(isUnpinned);
    }

    return isUnpinned;
};

const useIsHeaderHidden = (trigger) => {
    const [isHeaderHidden, setIsHeaderHidden] = useState(false);

    // if website header has "unpinned" css class then header is hidden
    const observedTarget = document.getElementById('header')?.getElementsByClassName('header-inner-v4')[0];

    const onScrollHandler = () => {
        checkHeader({action: setIsHeaderHidden, target: observedTarget});
    };

    useEffect(() => {
        if (trigger) {
            window.addEventListener('scroll', onScrollHandler);
        }

        return () => window.removeEventListener('scroll', onScrollHandler);
    }, [trigger]);

    if (trigger) {
        return checkHeader({target: observedTarget});
    }

    return isHeaderHidden;
};

export default useIsHeaderHidden;
